import { GET_ARTGASTOS } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {


    switch (action.type) {

        case GET_ARTGASTOS + "_SUCCESS":

            return action.payload.data;

        default:
            return state;
    }
}